import React from "react";
import { makeStyles, useTheme } from "@material-ui/styles";
import Particles from "react-particles-js";
import { Typography, Box, Grid, Button } from "@material-ui/core";
import { ReactComponent as Astro } from "../../assets/images/_emreastronaut.svg";

import styled from "styled-components";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#1c1f23",
  },
  particle: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
  },
}));
const AstroContainer = styled.div`
  position: absolute;
  left: 50%;
  bottom: ${(props) => props.bottom}vh;
  width: 130px;
  transform: rotate(${(props) => props.rotateDeg}deg);
  z-index: 1000;
`;

const ErrorPage = () => {
  const classes = useStyles();
  const [bottom, setBottom] = useState(0);
  const [transform, setTransform] = useState(120);
  const [direction, setDirection] = useState(1);
  const { t, i18n } = useTranslation();
  const astroRef = useRef(null);
  const theme = useTheme();

  const requestRef = React.useRef();
  const previousTimeRef = React.useRef();

  const animate = (time) => {
    if (previousTimeRef.current != undefined) {
      const deltaTime = time - previousTimeRef.current;
      setBottom((prevCount) => prevCount + direction * deltaTime * 0.01);
    }
    previousTimeRef.current = time;
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    if (bottom > 85) {
      setDirection(-1);
      requestRef.current = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(requestRef.current);
    }
    if (bottom < 1) {
      setDirection(1);
      requestRef.current = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(requestRef.current);
    }
  }, [bottom]);

  React.useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, []); // Make sure the effect runs only once

  return (
    <div className={classes.root}>
      <Grid container direction="column" alignItems="center" justify="center">
        <Grid item>
          <AstroContainer
            ref={astroRef}
            bottom={bottom}
            rotateDeg={bottom * 2 * direction}
          >
            <Astro />
          </AstroContainer>
        </Grid>
        <Grid item>
          <Box
            color={theme.palette.error.main}
            fontWeight={900}
            fontSize="11rem"
          >
            503
          </Box>
        </Grid>
        <Grid item md={4}>
          <Box
            marginTop="-20px"
            textAlign="center"
            fontSize="1.5rem"
            color="white"
          >
            {t(
              "Geçici Süre Hizmet Veremiyoruz, Lütfen Daha Sonra Tekrar Deneyiniz."
            )}
          </Box>
        </Grid>
      </Grid>

      <Particles
        className={classes.particle}
        params={{
          fps_limit: 60,
          particles: {
            number: {
              value: 355,
              density: {
                enable: true,
                value_area: 789.1476416322727,
              },
            },
            color: {
              value: "#ffffff",
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#000000",
              },
              polygon: {
                nb_sides: 5,
              },
              image: {
                src: "img/github.svg",
                width: 100,
                height: 100,
              },
            },
            opacity: {
              value: 0.48927153781200905,
              random: false,
              anim: {
                enable: true,
                speed: 0.2,
                opacity_min: 0,
                sync: false,
              },
            },
            size: {
              value: 2,
              random: true,
              anim: {
                enable: true,
                speed: 1,
                size_min: 0,
                sync: false,
              },
            },
            line_linked: {
              enable: false,
              distance: 150,
              color: "#ffffff",
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 0.644,
              direction: "left",
              random: false,
              straight: true,
              out_mode: "out",
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "bubble",
              },
              onclick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 400,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 83.91608391608392,
                size: 1,
                duration: 3,
                opacity: 1,
                speed: 3,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          retina_detect: false,
        }}
      />
    </div>
  );
};

export default ErrorPage;
